import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import CareTeam from "../../models/idg/company-team";
import PatientContact from "../../models/patient-chart/contacts/patient-contact";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class CareTeamsService {
  idgDataUrl: string;

  constructor(public http: HttpClient, private config: ConfigurationService) {
    this.idgDataUrl = config.resolveIdgUrl();
  }

  getAllTeams(size: number) {
    return this.http.get(
      `${this.idgDataUrl}/company-resources/teams?page=0&size=${size}`
    );
  }

  getCareTeamRoles(levelOfCare: string) {
    return this.http.get(
      `${this.idgDataUrl}/company-resources/roles?type=${levelOfCare}`
    );
  }

  getCareTeamMemberByRole(teamId, roleId) {
    return this.http.get(
      `${this.idgDataUrl}/company-resources/teams/${teamId}/members/role/${roleId}?search=`
    );
  }

  getCareTeamMembers(qbosId: string) {
    return this.http.get(
      `${this.idgDataUrl}/company-resources/careTeams/patient/${qbosId}`
    );
  }

  postCareTeamMembers(qbosId: string, data: any, validate: string) {
    return this.http.post(
      `${this.idgDataUrl}/company-resources/careTeams/patient/${qbosId}?validate=${validate}`,
      data
    );
  }

  putCareTeamMembers(qbosId: string, data: any, validate: string) {
    return this.http.put(
      `${this.idgDataUrl}/company-resources/careTeams/patient/${qbosId}?validate=${validate}`,
      data
    );
  }

  getPatientInfo(qbosId: string) {
    //Removing externalId=true parameter since we're using cognito
    return this.http.get(
      `${this.idgDataUrl}/company-resources/patient-charts/${qbosId}`
    );
  }

  getAllPhysicians() {
    return this.http.get(
      `${this.idgDataUrl}/company-resources/persons/physicians/all`
    );
  }

  getPatientPhysicians(qbosId: string) {
    return this.http.get(
      `${this.idgDataUrl}/patient-charts/${qbosId}/physicians`
    );
  }

  postPatientPhysician(qbosId: string, data: any) {
    return this.http.post(
      `${this.idgDataUrl}/patient-charts/${qbosId}/physicians`,
      data
    );
  }

  putPatientPhysician(qbosId: string, data: any) {
    return this.http.put(
      `${this.idgDataUrl}/patient-charts/${qbosId}/physicians`,
      data
    );
  }

  deletePatientPhysician(qbosId: string, contactId: string) {
    return this.http.delete(
      `${this.idgDataUrl}/patient-charts/${qbosId}/physicians/${contactId}`
    );
  }

  getCaregiverRelationships() {
    return this.http.get(
      `${this.idgDataUrl}/patient-charts/contacts/relationships`
    );
  }

  getPatientCaregivers(qbosId: string) {
    return this.http.get(
      `${this.idgDataUrl}/patient-charts/${qbosId}/contacts`
    );
  }

  getPatientCaregiversTyped(qbosId: number): Observable<PatientContact[]> {
    return this.http.get<PatientContact[]>(
      `${this.idgDataUrl}/patient-charts/${qbosId}/contacts`
    );
  }

  postPatientCaregiver(qbosId: string, data: any) {
    return this.http.post(
      `${this.idgDataUrl}/patient-charts/${qbosId}/contacts`,
      data
    );
  }

  putPatientCaregiver(qbosId: string, data: any) {
    return this.http.put(
      `${this.idgDataUrl}/patient-charts/${qbosId}/contacts`,
      data
    );
  }

  deletePatientCaregiver(qbosId: string, contactId: string) {
    return this.http.delete(
      `${this.idgDataUrl}/patient-charts/${qbosId}/contacts/${contactId}`
    );
  }

  getAllTeamsByTenant(): Observable<CareTeam[]> {
    return this.http.get<CareTeam[]>(
      `${this.idgDataUrl}/company-resources/teams/allTeams`
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/care-teams-service/care-teams-service.ts